import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import ModalContentBase from '../modal_content_base';
import ModalLoader from '../modal_loader';
import ModalAlert from '../modal_alert';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    circleId: PropTypes.number.isRequired,
    currentUser: PropTypes.object,
    isJoinRequestSent: PropTypes.bool,
    isRecruiting: PropTypes.bool,
    userSignedIn: PropTypes.bool,
    isRequestRequired: PropTypes.bool,
    isReloadRequired: PropTypes.bool,
    isButtonDisplay: PropTypes.bool,
    isNativeJoinRequest: PropTypes.bool,
    companyId: PropTypes.number,
    companyIdToParam: PropTypes.string,
  },
  getInitialState() {
    return {
      createdMessage: {},
      familyname: this.props.currentUser && this.props.currentUser.familyname,
      firstname: this.props.currentUser && this.props.currentUser.firstname,
      facebook: this.props.currentUser && this.props.currentUser.facebook_url,
      twitter: this.props.currentUser && this.props.currentUser.twitter_url,
      instagram: this.props.currentUser && this.props.currentUser.instagram_url,
      message: '',
      isJoinRequestSent: this.props.isJoinRequestSent,
      isSubmitting: false,
    };
  },
  getIntroductionTemplateFromServer() {
    $.ajax({
      type: 'GET',
      url: '/api/circle/self_introduction_templates',
      cache: false,
      data: {
        circle_id: this.props.circleId,
      },
    })
      .done(
        function (data) {
          this.setState({
            message: data ? data.description : '',
          });
        }.bind(this)
      )
      .fail(function () {}.bind(this));
  },
  changeFamilyname(e) {
    this.setState({
      familyname: e.target.value,
    });
  },
  changeFirstname(e) {
    this.setState({
      firstname: e.target.value,
    });
  },
  changeMessage(e) {
    this.setState({
      message: e.target.value,
    });
  },
  changeFacebook(e) {
    this.setState({
      facebook: e.target.value,
    });
  },
  changeTwitter(e) {
    this.setState({
      twitter: e.target.value,
    });
  },
  changeInstagram(e) {
    this.setState({
      instagram: e.target.value,
    });
  },
  sendMemberJoinRequest() {
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    const { circleId } = this.props;
    this.modalLoader.openModal();
    $.ajax({
      url: '/api/circle/send_join_request',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        circle_id: circleId,
        self_introduction: this.state.message,
        familyname: this.state.familyname,
        firstname: this.state.firstname,
        facebook: this.state.facebook,
        twitter: this.state.twitter,
        instagram: this.state.instagram,
      },
    })
      .done(
        function (data) {
          this.modalLoader.closeModal();
          this.setState({
            createdMessage: data.createdMessage,
            isJoinRequestSent: true,
          });
          if (this.props.isReloadRequired) {
            location.reload();
          }
        }.bind(this)
      )
      .fail(
        function (_xhr, _status, data) {
          // error
          this.setState({ isSubmitting: false });
          this.modalLoader.closeModal();
          if (data === 'Forbidden') {
            this.disableJoinErrorAlert.openModal();
          } else {
            this.systemErrorAlert.openModal();
          }
        }.bind(this)
      );
  },
  handleMemberJoinImmediatelyButton() {
    if (this.props.userSignedIn) {
      this.sendMemberJoinImmediately();
    } else {
      this.signInAlert.openModal();
    }
  },
  sendMemberJoinImmediately() {
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    const { circleId, companyId, companyIdToParam } = this.props;
    this.modalLoader.openModal();
    $.ajax({
      url: '/api/circle/send_join_immediately',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        circle_id: circleId,
        self_introduction: this.state.message,
        familyname: this.state.familyname,
        firstname: this.state.firstname,
        facebook: this.state.facebook,
        twitter: this.state.twitter,
        instagram: this.state.instagram,
      },
    })
      .done(
        function () {
          this.modalLoader.closeModal();
          if (this.props.isReloadRequired) {
            location.reload();
          } else {
            window.location.href =
              companyId ? '/community/' + companyIdToParam + '/circle/' + circleId.toString() : '/circle/' + circleId.toString();
          }
        }.bind(this)
      )
      .fail(
        function (_xhr, _status, data) {
          // error
          this.setState({ isSubmitting: false });
          this.modalLoader.closeModal();
          if (data === 'Forbidden') {
            this.disableJoinErrorAlert.openModal();
          } else {
            this.systemErrorAlert.openModal();
          }
        }.bind(this)
      );
  },
  componentDidMount() {
    this.getIntroductionTemplateFromServer();
  },
  componentDidUpdate() {
    if (this.props.isJoinRequestSent && !this.state.isJoinRequestSent) {
      this.setState({
        isJoinRequestSent: this.props.isJoinRequestSent,
      });
    }
  },
  closeModalBtn() {
    this.modalJoinRequest.closeModal();
  },
  validate() {
    return this.state.familyname === null || this.state.firstname === null || this.state.isSubmitting;
  },
  render() {
    let previewContent = '';
    let baseContent = '';
    if (this.props.isButtonDisplay) {
      if (this.props.isNativeJoinRequest) {
        baseContent = (
          <p className="mb-0">
            <button
              onClick={() => {
                window.location.href = `/circle/${this.props.circleId}/${
                  this.props.isRequestRequired
                    ? 'application'
                    : 'application_immediately'
                }`;
              }}
              className="member-join-button w-100 mb-0"
              disabled={
                this.state.isJoinRequestSent || !this.props.isRecruiting
              }
            >
              <img
                src="/img/tunagate_tobira.svg"
                alt="メンバー申請ボタン"
                style={{filter: this.state.isJoinRequestSent ? 'grayscale(1.0)' : ''}}
              />
              <span>{this.props.isRequestRequired ? 'メンバー申請' : 'メンバーになる'}</span>
            </button>
            {this.state.isJoinRequestSent && <span className="text-fz-small">参加申請中です</span>}
          </p>
        );
      } else {
        previewContent = (
          <p className="mb-0">
            <button
              type="button"
              className="member-join-button w-100 mb-0"
              disabled={this.state.isJoinRequestSent || !this.props.isRecruiting}
            >
              <img
                src="/img/tunagate_tobira.svg"
                alt="メンバー申請ボタン"
                style={{filter: this.state.isJoinRequestSent ? 'grayscale(1.0)' : ''}}
              />
              <span>{this.props.isRequestRequired ? 'メンバー申請' : 'メンバーになる'}</span>
            </button>
            {this.state.isJoinRequestSent && <span className="text-fz-small">参加申請中です</span>}
          </p>
        );
      }
    } else {
      previewContent = (
        <p>
          <a className="text-primary" style={{ fontSize: '12px' }}>
            このサークルに参加申請する
          </a>
        </p>
      );
    }

    let userNameForm = '';
    if (this.props.userSignedIn) {
      if (
        this.props.currentUser.familyname === null ||
        this.props.currentUser.firstname === null
      ) {
        userNameForm = (
          <div>
            <p className="mt20 bold red" style={{ textAlign: 'left' }}>
              <i className="fas fa-exclamation-triangle" />
              &nbsp;まだお名前の登録が完了していません。
            </p>
            <div
              className="flex mt10 width-full"
              style={{ alignItems: 'center' }}
            >
              <p>
                <i className="fas fa-user mr10" />
              </p>
              <input
                type="text"
                placeholder="姓"
                className="mr5"
                style={{ width: '50%', padding: '5px' }}
                onChange={this.changeFamilyname}
                value={this.state.familyname}
              />
              <input
                type="text"
                placeholder="名"
                style={{ width: '50%', padding: '5px' }}
                onChange={this.changeFirstname}
                value={this.state.firstname}
              />
            </div>
          </div>
        );
      }
    }

    let modalContent = '';
    if (!this.state.isJoinRequestSent && this.props.isRecruiting) {
      if (this.props.isRequestRequired) {
        modalContent = (
          <div className="card bg-gray" style={{ padding: '16px 16px 100px' }}>
            <button
              type="button"
              className="close close__modal position-absolute position--modalclose"
              aria-label="Close"
              onClick={this.closeModalBtn}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h6 className="text-fw-bold text-center mb-3_5">
              メンバー申請へ進む
            </h6>
            {userNameForm}
              <div className="card bg-white scrollable-list-y border-0 p-3 mb-2">
                <textarea
                  className="textarea--eventreport"
                  name=""
                  id=""
                  cols="30"
                  rows="4"
                  defaultValue={this.state.message}
                  onChange={this.changeMessage}
                  placeholder="はじめまして、〇〇と申します。&#13;&#10;趣味は..."
                />
              </div>
            <button
              className="a-button a-button__top a-button--orange mr-auto ml-auto mt-2 mb-2 w-100"
              onClick={
                this.props.isRequestRequired
                  ? this.sendMemberJoinRequest
                  : this.handleMemberJoinImmediatelyButton
              }
              disabled={this.validate()}
            >
              メンバー申請へ進む
            </button>
          </div>
        );
      } else {
        modalContent = (
          <div className="card bg-gray" style={{ padding: '40px 16px 40px' }}>
            <button
              type="button"
              className="close close__modal position-absolute position--modalclose"
              aria-label="Close"
              onClick={this.closeModalBtn}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h6 className="text-fw-bold text-center mb-3_5">
              メンバーになる
            </h6>
            <p className="text-black-50 text-fz-12px text-center mb-3">
              このサークルは承認不要です。ボタンを押すとすぐにメンバーになります。
            </p>
            <button
              className="a-button a-button__top a-button--orange mr-auto ml-auto mt-2 mb-2 w-100"
              onClick={
                this.props.isRequestRequired
                  ? this.sendMemberJoinRequest
                  : this.handleMemberJoinImmediatelyButton
              }
              disabled={this.validate()}
            >
              メンバーになる
            </button>
          </div>
        );
      }
    } else if (this.state.isJoinRequestSent) {
      modalContent = (
        <div>
          <div className="modal-view-header">
            <p
              className="bold"
              style={{ margin: '0px 0px 6px', paddingTop: '1.5em' }}
            >
              メンバー申請完了
            </p>
          </div>
          <div>
            <p className="mb-4 text-center">
              現在このサークルにメンバー申請をしています。
            </p>
          </div>
        </div>
      );
    } else if (!this.props.isRecruiting) {
      modalContent = (
        <div>
          <div className="modal-view-header">
            <p
              className="bold"
              style={{ margin: '0px 0px 6px', paddingTop: '1.5em' }}
            >
              メンバー申請ができません
            </p>
          </div>
          <div className="modal-view-body" style={{ paddingBottom: '2em' }}>
            <p>このサークルは現在メンバーの募集を申請をしていません。</p>
          </div>
        </div>
      );
    }
    return (
      <div>
        {baseContent}
        <ModalContentBase
          ref={(c) => {
            this.modalJoinRequest = c;
          }}
          previewContent={previewContent}
          modalContent={modalContent}
        />
        <ModalLoader
          ref={(c) => {
            this.modalLoader = c;
          }}
        />
        <ModalAlert
          ref={(c) => {
            this.signInAlert = c;
          }}
          title="ログイン"
          content="この操作にはログインまたは会員登録が必要です。"
        />
        <ModalAlert
          ref={(c) => {
            this.systemErrorAlert = c;
          }}
          title="エラー"
          content="時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.disableJoinErrorAlert = c;
          }}
          title="エラー"
          content="お客様は、このサークルのイベントに参加する権限がございません。"
        />
      </div>
    );
  },
});
